import { logout } from "../api/auth.js";

interface ImpersonationBannerProps {
  impersonatingAdminId: string;
}

export function ImpersonationBanner({
  impersonatingAdminId,
}: ImpersonationBannerProps) {
  async function handleExit() {
    await logout();
    window.location.href = "/admin";
  }

  return (
    <div
      role="alert"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: "#b45309",
        color: "#fff",
        padding: "8px 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        fontSize: "14px",
      }}
    >
      <span>
        ⚠ Admin impersonation active (admin: {impersonatingAdminId.slice(0, 8)}
        …)
      </span>
      <button
        type="button"
        onClick={() => void handleExit()}
        style={{
          background: "transparent",
          border: "1px solid #fff",
          color: "#fff",
          padding: "4px 12px",
          borderRadius: "4px",
          cursor: "pointer",
          fontSize: "13px",
        }}
      >
        Exit impersonation
      </button>
    </div>
  );
}
